import script from "./MenuMain.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMain.vue?vue&type=script&setup=true&lang=js"

import "./MenuMain.vue?vue&type=style&index=0&id=0b6821cb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6821cb"]])

export default __exports__